import React, { Component } from 'react';
import "./styles/CardRadio.css";

export class CardRadio extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: this.props.selected,
            hover: false,
        }
    }
    toggleHover = () => {
        this.setState({
            hover: !this.state.hover
        });
    }
    onClick = () => {
        this.setState({ selected: true, hover: false });
        if (this.props.onClick) {
            this.props.onClick(this.props.id);
        }
    }
    render() {
        //var buttonStyle;
        //if (this.state.hover) {
        //    buttonStyle = { backgroundColor: 'lightgreen' }
        //} else {
        //    buttonStyle = { backgroundColor: 'aliceblue' }
        //}       //<button style={buttonStyle} onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}
        return (
            <div className={`${this.props.optionClass}`}>
                <button
                    className={`form-control ${this.props.CardStyle}  ${this.state.selected === true && this.props.id === this.props.currentSelected ? "OptionSelected" : ""}`}
                    onClick={this.onClick}>
                    <label>{this.props.label}</label>
                </button>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/common/CardRadio.js